const CardDeckInfo = [
  {
    id: 0,
    src: "https://images.unsplash.com/photo-1554136512-5d996b22f5fa?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    alt: "Food at Bangkok Hill",
    title: "TRADITIONAL FAVORITES",
    description:
      "Our menu features delicious Thai delicacies that are sure to please, from savory noodle dishes to aromatic curries.",
  },
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1504718855392-c0f33b372e72?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=668&q=80",
    alt: "Restaurant",
    title: "SERVED WITH WARMTH",
    description:
      "Here, you'll feel like home. Enjoy our cozy indoor seating with friends and family, or soak up the sun on our patio with a refreshing Thai iced tea.",
  },
  {
    id: 2,
    src: "https://images.pexels.com/photos/5409662/pexels-photo-5409662.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
    alt: "Staff Photo",
    title: "CRAFTED WITH LOVE",
    description:
      "We pride ourselves on making delicious food that reflects our cultural heritage.",
  },
];

export default CardDeckInfo;
